/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from "jquery";
import jQueryBridget from "jquery-bridget";
import Masonry from "masonry-layout";
import { JQueryFancyInit } from "./jqueryFancy/jquery-fancy.js";

const filter = {
    sortByCategory: "",
    sortByDate: "desc",
    nextOffset: ""
};

class PostGrid {
    constructor() {
        this.init();
    }

    init() {
        // make Masonry a jQuery plugin
        jQueryBridget("masonry", Masonry, $);
        JQueryFancyInit($);

        // the interval is because the grid load by ajax and we don't have access to success response
        const intervalExist = setInterval(() => {
            const $gridItem = $(".grid-item");

            if ($gridItem.length > 0) {
                // now you can use $().masonry()
                $(".grid").masonry({
                    columnWidth: ".grid-sizer",
                    itemSelector: ".grid-item",
                    percentPosition: true,
                    horizontalOrder: true,
                });
                clearInterval(intervalExist);
            }
        }, 100);

        this.getPostGrid();
        this.initModal();
        this.getSortFilter();
        this.getCategoryOptions();
        this.getCategoryFilter();
    }

    initModal() {
        const intervalExist = setInterval(() => {
            const $spotlight = $(".spotlight");

            if ($spotlight.length > 0) {
                $(".spotlight").fancybox();
                clearInterval(intervalExist);
            }
        }, 100);
    }

    getPostGrid() {
        $.ajax({
            type: "GET",
            url: `/wp-json/clf/v1/grid?offset=${filter.nextOffset}&order=${filter.sortByDate}&categories=${filter.sortByCategory}`,
            success: (dataGrid) => {
                if (dataGrid != undefined) {
                    filter.nextOffset = dataGrid.nextOffset;
                    this.renderNewsCard(dataGrid.data);
                    this.getMoreNews();
                    $(".loader").addClass("hide-loader");
                }
            },
            error: function () {
                //Error block
                console.log("error");
            },
        });
    }

    renderNewsCard(cards) {
        const $container = $("#clf-grid");

        if (!cards) {
            return '';
        }

        const newsItem = cards.map((item, index) => {
            /*let isModalLink =
                item.postType === "spotlight"
                    ? `<a href="#spotlight-${index}" class="${item.postType}">Read More</a>`
                    : `<a href="${item.link}" class="${item.postType}">Read More</a>`;*/
            let isModalLink = `<a href="${item.link}" class="${item.postType}">Read More</a>`;


            if (item.postType === "spotlight" ) 
                isModalLink = `<a href="#spotlight-${index}" class="${item.postType}">Read More</a>`;

            if (!!item.is_external && item.external_url.length > 0)
                isModalLink = `<a href="${item.external_url}" target="_blank" class="${item.postType}">Read More</a>`;

            
            let renderModal =
                item.postType === "spotlight" ? this.renderModal(item, index) : "";
            const validateTitle =
                item.spotlightData &&
                    item.spotlightData.spotlightType === "with_subtitle"
                    ? "sub-title"
                    : "";

            if (index === 0) {
                return `<div class="grid-item clf-col-lg">
                            <div class="clf-card clf-card-large ${item.postType}">
                                <div class="card-image-container">
                                    <img class="card-img-top" src="${item.image}" alt="${item.title}">
                                </div>
                                <div class="clf-card-body">
                                    <span class="date">${item.date}</span>
                                    <h5>${item.title}</h5>
                                    <p class="${validateTitle}">${item.excerpt}</p>
                                    ${isModalLink}
                                    <span class="category">${item.category}</span>
                                </div>
                            </div>
                            ${renderModal}
                        </div>`;
            }

            return `<div class="grid-item clf-col-grid">
                        <div class="clf-card clf-${item.postType}">
                            <div class="card-image-container">
                                <img class="card-img-top" src="${item.image}" alt="${item.title}">
                            </div>
                            <div class="clf-card-body">
                                <span class="date">${item.date}</span>
                                <h5>${item.title}</h5>
                                <p class="${validateTitle}">${item.excerpt}</p>
                                ${isModalLink}
                                <span class="category">${item.category}</span>
                            </div>
                        </div>
                        ${renderModal}
                    </div>`;
        });

        $container.append(newsItem).each(function () {
            $(".grid").masonry("reloadItems");
        });
        $container.masonry();
    }

    renderModal(item, index) {
        const mediaValidation = item.spotlightData.is_video
            ? `<iframe src="${item.spotlightData.media}"></iframe>`
            : `<img src="${item.spotlightData.media.url}" alt="${item.title}">`;
        const validateSubTitle =
            item.spotlightData &&
                item.spotlightData.spotlightType === "with_subtitle"
                ? `<h5>${item.excerpt}</h5>`
                : "";

        return (
            `<div id="spotlight-${index}" style="display:none">
                    <div class="clf2020-modal-container">
                        <div class="media-container">
                            ${mediaValidation}
                        </div>
                        <div class="body-container">
                            <div class="content-left">
                                <h2>${item.title}</h2>
                                ${validateSubTitle}
                                <p>${item.spotlightData.content}</p>
                            </div>
                            <div class="content-right">
                                <h4>${item.spotlightData.related_content_title}</h4>
                                <ul>` +
            this.renderRelated(item.spotlightData) +
            `</ul>
                            </div>
                        </div>
                    </div>
                </div>`
        );
    }

    renderRelated(related) {
        if (related.related_content === undefined) {
            return "";
        }

        return related.related_content
            .map((item) => {
                return "<li><a href=" + item.url + ">" + item.title + "</a></li>";
            })
            .join("");
    }

    renderLoadMoreCards(cards) {
        const $container = $("#clf-grid");

        const newsItem = cards.map((item, index) => {
            let isModalLink =
                item.postType === "spotlight"
                    ? `<a href="#spotlight-${index}" class="${item.postType}">Read More</a>`
                    : `<a href="${item.link}" class="${item.postType}">Read More</a>`;
            let renderModal =
                item.postType === "spotlight" ? this.renderModal(item, index) : "";
            const validateTitle =
                item.spotlightData &&
                    item.spotlightData.spotlightType === "with_subtitle"
                    ? "sub-title"
                    : "";

            return `<div class="grid-item clf-col-grid">
                        <div class="clf-card clf-${item.postType}">
                            <div class="card-image-container">
                                <img class="card-img-top" src="${item.image}" alt="${item.title}">
                            </div>
                            <div class="clf-card-body">
                                <span class="date">${item.date}</span>
                                <h5>${item.title}</h5>
                                <p class="${validateTitle}">${item.excerpt}</p>
                                ${isModalLink}
                                <span class="category">${item.category}</span>
                            </div>
                        </div>
                        ${renderModal}
                    </div>`;
        });

        $container.append(newsItem).each(function () {
            $(".grid").masonry("reloadItems");
        });
        $container.masonry();
    }

    getMoreNews() {
        $("#btn-load-more").click(() => {
            const pagination = $("#btn-load-more").attr('data-pagination');
            $(".loader-bottom").removeClass("hide-loader");
            $.ajax({
                type: "GET",
                url: `/wp-json/clf/v1/grid?offset=${filter.nextOffset}&order=${filter.sortByDate}&categories=${filter.sortByCategory}&pp=${pagination}`,
                success: (moreDataNews) => {
                    if (moreDataNews != undefined) {
                        filter.nextOffset = moreDataNews.nextOffset;
                        this.hideButton(filter.nextOffset);
                        this.renderLoadMoreCards(moreDataNews.data);
                        $(".loader-bottom").addClass("hide-loader");
                    }
                },
                error: function () {
                    //Error block
                    console.log("error");
                },
            });
        });
    }

    hideButton(nextOffset) {
        if (nextOffset !== null) {
            $("#btn-load-more").show();
        } else if (nextOffset === null) {
            $("#btn-load-more").hide();
        }
    }

    getSortFilter() {
        $(".sort-option").click((e) => {
            this.onSortFilter(e);
        });

        $(".sort-option").keydown((e) => {
            if (e.keyCode === 13) {
                this.onSortFilter(e);
            }
        });
    }

    onSortFilter(e) {
        const sortOption = e.target.getAttribute('data-sort');
        filter.sortByDate = sortOption;
        filter.nextOffset = "";

        $(".loader").removeClass("hide-loader");
        $(".grid-item").remove();

        $.ajax({
            type: "GET",
            url: `/wp-json/clf/v1/grid?offset=${filter.nextOffset}&order=${filter.sortByDate}&categories=${filter.sortByCategory}`,
            success: (dataGrid) => {
                if (dataGrid != undefined) {
                    this.renderNewsCard(dataGrid.data);
                    this.hideButton(dataGrid.nextOffset);
                    this.initModal();
                    $(".loader").addClass("hide-loader");
                }
            },
            error: function () {
                //Error block
                console.log("error");
            },
        });
    }

    renderCategoryOptions(renderCategoriesOption) {
        const $categoriesSelect = $(".dropdown-category .menu");
        const allOptions = `<div data-sort="" class="category-option"><span class="inner" data-sort="" tabindex="-1">All</span></div>`

        if (!renderCategoriesOption) return '';

        const categoriesOption = renderCategoriesOption.map((item) => {
            return `<div data-sort="${item.slug}" class="category-option" tabindex="0"><span class="inner" data-sort="${item.slug}" tabindex="-1">${item.name}</span></div>`
        }).join("");

        $categoriesSelect.append(allOptions);
        $categoriesSelect.append(categoriesOption);
    }

    getCategoryOptions() {
        $.ajax({
            type: "GET",
            url: "/wp-json/wp/v2/categories",
            success: (dataCategories) => {
                if (dataCategories != undefined) {
                    this.renderCategoryOptions(dataCategories);
                }
            },
            error: function (e) {
                //Error block
                console.log("getCategoryOptions::error", e);
            },
        });
    }

    getCategoryFilter() {
        const intervalExist = setInterval(() => {
            const $categoryOption = $(".category-option");

            if ($categoryOption.length > 0) {
                $(".category-option").click((e) => {
                    this.onCategoryFilter(e);
                });
                $(".category-option").keydown((e) => {
                    if (e.keyCode === 13) {
                        this.onCategoryFilter(e);
                    }
                });
                clearInterval(intervalExist);
            }
        }, 100);
    }

    onCategoryFilter(e) {

        const dataAttrOption = e.target.getAttribute('data-sort');

        filter.sortByCategory = dataAttrOption;
        filter.nextOffset = "";
        $(".loader").removeClass("hide-loader");
        $(".grid-item").remove();

        $.ajax({
            type: "GET",
            url: `/wp-json/clf/v1/grid?offset=${filter.nextOffset}&order=${filter.sortByDate}&categories=${filter.sortByCategory}`,
            success: (dataGrid) => {
                if (dataGrid != undefined) {
                    filter.nextOffset = dataGrid.nextOffset;
                    this.renderNewsCard(dataGrid.data);
                    this.hideButton(dataGrid.nextOffset);
                    this.initModal();
                    $(".loader").addClass("hide-loader");
                }
            },
            error: function (e) {
                //Error block
                console.log("getCategoryFilter::error", e);
            },
        });
    }
}

export default PostGrid;
